// extracted by mini-css-extract-plugin
export default {"mc":"style-module--mc--s+lkK","mcv":"style-module--mcv--5ZpIh"};